module.exports = __webpack_public_path__ + "static/media/img1.dbfb6764.jpg";